import { createFileRoute } from '@tanstack/react-router'
import Blog from 'pages/blog/[blog-slug]'
import { getBlogPost } from 'components/blog/posts'
import {
   articleSchema,
   canonicalLink,
   isoDate,
   ldJsonScript,
   ogCard,
   ogCardPath,
   pageMeta,
   SITE_URL,
} from 'lib/seo'

// The newer bespoke posts. Their frontmatter is parsed at import time, so the
// title is available at match time without loading the component's chunk.
export const Route = createFileRoute('/blog/$blogSlug')({
   head: ({ params }) => {
      const post = getBlogPost(params.blogSlug)
      if (!post) {
         return { meta: [{ title: 'Article not found' }] }
      }
      const { title, metaDescription, author, date } = post.meta
      const url = `${SITE_URL}/blog/${params.blogSlug}`
      return {
         meta: pageMeta({
            title,
            description: metaDescription,
            url,
            ogType: 'article',
            // Rendered by `npm run generate:og-cards` from this post's own
            // frontmatter, so the feed card and the page's hero stay in step.
            image: ogCard(params.blogSlug, title),
            article: { publishedTime: isoDate(date), author },
         }),
         links: [canonicalLink(url)],
         scripts: [
            ldJsonScript(
               articleSchema({
                  url,
                  headline: title,
                  description: metaDescription,
                  datePublished: isoDate(date),
                  author,
                  image: ogCardPath(params.blogSlug),
               })
            ),
         ],
      }
   },
   component: Blog,
})
